import { create } from 'zustand';

interface MessagingUser {
  id: string;
  name: string;
}

interface MessagingState {
  activeMessagingUser: MessagingUser | null;
  openMessaging: (user: MessagingUser) => void;
  closeMessaging: () => void;
}

export const useMessagingStore = create<MessagingState>((set) => ({
  activeMessagingUser: null,
  openMessaging: (user) => set({ activeMessagingUser: user }),
  closeMessaging: () => set({ activeMessagingUser: null }),
}));